import { __assign } from "tslib";
/* I82B in DS */
import React from 'react';
import IconWrap from '../../IconWrap';
var AddToGroupFill = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
            React.createElement("path", { d: "M13.0166 10l1.35 4H9.7732l-1.35-4h4.5933zm-6 0l1.35 4H1l1.35-4h4.6666zm4-8c1.841 0 3.3333 1.4924 3.3333 3.3333 0 1.841-1.4923 3.3334-3.3333 3.3334-1.0138 0-1.922-.4527-2.5333-1.1668.3409-.6471.5333-1.3844.5333-2.1666 0-.782-.1924-1.5192-.5324-2.1666C9.0946 2.4527 10.0028 2 11.0166 2zM4.3499 2c1.841 0 3.3334 1.4924 3.3334 3.3333 0 1.841-1.4924 3.3334-3.3334 3.3334-1.841 0-3.3333-1.4924-3.3333-3.3334C1.0166 3.4923 2.509 2 4.3499 2z", fillRule: "evenodd" }))));
};
AddToGroupFill.displayName = 'AddToGroupFill';
export default AddToGroupFill;
//# sourceMappingURL=AddToGroupFill.js.map